import React from 'react';

import SoftyGrupoDetails from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/Softys/SoftyGrupo/SoftyGrupoDetails/List.js';

export default function () {
  return <SoftyGrupoDetails />;
}
